/**
 * personalTaskService — the PERSONAL space's task collection (`personalTasks`).
 *
 * Same machinery as Work (see taskServiceFactory.js), pointed at a separate
 * owner-walled collection. `/personalTasks` and its subtasks/comments
 * subcollections allow read+write only to isOwner() — users/{uid}.owner == true,
 * which is Anthony and Grace and deliberately NOT isAdmin(), so a non-owner
 * admin is denied. A rules test asserts exactly that, because it is what proves
 * the gate keys on `owner` rather than on `role`.
 *
 * NO CATEGORIES, deliberately. `taskCategories` is gated isEmployeeOrAdmin(), so
 * an owner could technically write to it — which is the accident worth
 * preventing: a household category would surface in the studio's category list.
 * Under the user-defined property model a category is just a select property, so
 * this space is unlikely ever to need that collection. The four category
 * functions throw a descriptive error here rather than silently no-op.
 *
 * Read markers ARE shared with Work (`taskReads`): the collection is keyed
 * `{uid}_{taskId}` and self-scoped by uid, never by a task's collection, so one
 * marker set serves every space.
 *
 * NOT YET MOUNTED. No UI reads this service — the Work module's components
 * import task functions at module level, so mounting them against Personal needs
 * the service passed down rather than imported. That is the next slice.
 */

import { createTaskService } from './taskServiceFactory';

const personalTaskService = createTaskService({
	tasksCollection: 'personalTasks',
	space: 'personal',
	// categoriesCollection deliberately omitted — see above.
});

export default personalTaskService;
